export default __webpack_public_path__ + "static/media/Acrylic-Paints.53b2a0fe.png";